<template>
  <v-app light>
    <v-main>
      <v-container
        fill-height
        fluid
        class="pa-0"
        light
      >
        <v-row class="fill-height">
          <v-col
            class="d-flex flex-column justify-center align-center"
            cols="12"
            md="5"
          >
            <div
              style="width:60%"
              class="text-center my-auto"
            >
              <div class="mb-6">
                <v-img
                  contain
                  class="mx-auto"
                  max-width="100"
                  max-height="100"
                  src="@/assets/images/commons/haulier-logo.svg"
                />
              </div>

              <router-view />
            </div>

            <v-footer class="transparent py-5">
              <div class="grey--text caption">
                Copyright &copy; 2020 Haulier. All rights reserved.
              </div>
            </v-footer>
          </v-col>

          <v-col
            class="d-none d-md-block black ma-0 pa-0"
            sm="7"
          >
            <v-carousel
              cycle
              height="100vh"
              :show-arrows="false"
              hide-delimiter-background
            >
              <v-carousel-item
                v-for="(item,i) in items"
                :key="i"
              >
                <v-img
                  class="fill-view-height"
                  :src="(item.src)"
                >
                  <v-row
                    align="center"
                    justify="center"
                    class="fill-height text-center"
                  >
                    <v-col cols="9">
                      <div class="orange--text display-1 mb-5">
                        {{ item.title }}
                      </div>
                      <div class="px-10">
                        {{ item.subtitle }}
                      </div>
                    </v-col>
                  </v-row>
                </v-img>
              </v-carousel-item>
            </v-carousel>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
export default {
  data() {
    return {
      items: [
        {
          title: 'We Offer Transport',
          subtitle:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley",
          src: require('@/assets/images/accounts/slider-1.jpeg'),
        },
        {
          title: 'Making Transportation Fast & Safe',
          subtitle:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley",

          src: require('@/assets/images/accounts/slider-2.jpeg'),
        },
        {
          title: 'Warehousing Storage',
          subtitle:
            "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley",

          src: require('@/assets/images/accounts/slider-3.jpeg'),
        },
      ],
    };
  },
};
</script>

<style scoped>
.fill-view-height {
  height: 100vh !important;
}

.footer {
  position: absolute;
  bottom: 0;
}
</style>
